export enum FilterValueTypeEnum {
  nonmissing = 'nonmissing',
  minmax = 'minmax',
  exactmatch = 'exactmatch',
  anymatch = 'anymatch',
}